module.exports = __webpack_public_path__ + "static/media/jp.95c2abfe.svg";